<div class="overlay">
  <div class="container">
    <div class="loader">
      @if (success) {
        <mat-icon class="text-success success-icon">check_circle</mat-icon>
      }
      {{ getTranslation(overlayMessage) }}
      <br />
      <span>
        {{ getTranslation(overlaySubTitle) }}
      </span>
      <br /><br />
      @if (loaderBar) {
        <mat-progress-bar [mode]="'indeterminate'" />
      }
      <br><br>
      @if (exitUrl) {
        <a [href]="exitUrl" class="btn btn-primary">Ok, chiudi</a>
      }
    </div>
  </div>
</div>